const ErrorBoundaryTypes = {
    log: 1,
    logPopup: 2,
    logPopupRefresh: 3,
    refreshBack: 4,
    fatalError: 5,
}

export default ErrorBoundaryTypes